// Feature flags del sitio de Finca Los Astros.
//
// Estas secciones se ocultan mientras la bodega está en construcción.
// NO se elimina código: para re-habilitar una sección, poner su flag en `true`.
export const FEATURES = {
    // Secciones públicas (Home + navbar público)
    eventos: false,
    wineAsAService: true,
    cai: true,
    preguntasFrecuentes: false,

    // Secciones del área de miembros (navbar de miembro)
    demostraciones: false,
    catas: false,        // /degustaciones
    reservas: false,     // "Sus Reservas"

    // "Cupo asignado": queda visible pero deshabilitado hasta habilitar la tienda.
    cupoHabilitado: false,

    // Bloque de beneficios en la página de Lista de Espera
    beneficiosListaEspera: false,
};
